import catchify from 'catchify';

export default (context, inject) => {
  const convert = async (metrics) => {
    const { $cookies } = context;

    const [err, response] = await catchify(context.$axios({
      method: 'post',
      url: '/api/sumotest/convert/',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': $cookies.get('csrftoken'),
      },
      data: {
        metrics,
      },
    }));

    if (err) {
      // eslint-disable-next-line no-console
      console.log('Error Experiment Convert:', err);
      return;
    }

    const { data } = response;

    if (data && !data.success) {
      // eslint-disable-next-line no-console
      console.log('Error Experiment Convert: ', data.error);
    }
  };

  // NOTE: if using `true` or `false` variant slugs, server returns as string,
  //  but cookie saves as a boolean
  const enroll = async (name, checkCookie = true) => {
    const { $cookies, $axios } = context;

    const override = context.query[`sumotest-${name}`];
    const reset = String(context.query[`sumotest-reset-${name}`]) === '1';

    if (override) {
      return override;
    }

    if (reset) {
      $cookies.remove(`__experiment_${name}`);
    } else if (checkCookie) {
      const existExp = $cookies.get(`__experiment_${name}`);

      if (existExp) {
        return existExp;
      }
    }

    let query = `experiment=${encodeURIComponent(name)}`;
    if (reset) {
      query += `&sumotest-reset-${name}=1`;
    }
    // Add isMobile query param if user is on mobile
    // Use viewport width to determine if mobile
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      query += '&isMobile=1';
    }

    const [err, response] = await catchify($axios({
      method: 'GET',
      url: `/api/sumotest/enroll/?${query}`,
      withCredentials: true,
    }));

    if (err) {
      console.log('Error Enrolling in Experiment:', name, err); // eslint-disable-line no-console
      return null;
    }

    const variant = (response && response.data && response.data.variant) || '';

    // Avoid sending headers twice in case experiments were not
    // enrolled properly. Ex: on created()
    if (process.server && context.res && context.res.headersSent) {
      console.log( // eslint-disable-line no-console
        `Experiment ${name} variant ${variant} error. Headers already sent. Cannot set cookie.`,
      );
      return variant;
    }

    if (variant) {
      $cookies.set(`__experiment_${name}`, variant, {
        path: '/',
        maxAge: 60, // Expire after 1 min
      });
    }

    return variant;
  };

  const getVariantsWithoutEnrolling = async (names) => {
    // Accepts an array of experiment slugs
    // Returns an object with the experiment slugs as keys and the variant as values
    const { $cookies } = context;
    const returnVal = {};
    const slugsToFetch = [];
    for (let i = 0; i < names.length; i += 1) { // NOSONAR
      const name = names[i];
      // Check if cookie exists
      const existExp = $cookies.get(`__experiment_${name}`)
        || $cookies.get(`__experiment_not_enrolled_${name}`);
      if (existExp) {
        returnVal[name] = existExp;
      } else {
        slugsToFetch.push(name);
      }
    }
    // Fetch any slugs that don't have a cookie
    if (slugsToFetch.length > 0) {
      // Endpoint expects a pipe separated list of experiment slugs
      const [err, response] = await catchify(
        context.$axios({
          method: 'GET',
          url: `/api/sumotest/get_variants/?experiments=${slugsToFetch.join('|')}`,
          withCredentials: true,
        }),
      );
      if (err) {
        console.error('Error getting experiment variants: ', err); // eslint-disable-line no-console
        return returnVal;
      }
      const { data } = response;
      if (data && data.data) {
        Object.keys(data.data).forEach((experiment) => {
          const variant = data.data[experiment];
          returnVal[experiment] = variant;
          // Use __experiment_not_enrolled_${name} cookie to avoid hitting endpoint again
          // and not interfering with the enroll function
          $cookies.set(`__experiment_not_enrolled_${experiment}`, variant, {
            path: '/',
            maxAge: 60, // Expire after 1 min
          });
        });
      }
    }
    return returnVal;
  };

  const experiments = {
    convert,
    enroll,
    getVariantsWithoutEnrolling,
  };

  inject('experiments', experiments);
  context.$experiments = experiments;
};
